// extracted by mini-css-extract-plugin
module.exports = {"ticketTaskCard":"_3p52dppemM7_Pc5STGo_EH","ticketTaskCardDetail":"_1xdVmYGMZv8GhsU8fbuKYG"};